(ns storrito.paywall
  (:require [storrito.state.core :as state]
            [ui.core]))

(defn ^:export disablePaywall []
  (prn "hide-paywall")
  (swap! state/state assoc :hide-paywall true)
  (let [store (:ui/store @ui.core/system)]
    (swap! store assoc :hide-paywall true)))